var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/web_health_network_icon.png"),"alt":"web health network icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }